import React, { useState, useEffect } from 'react';
import styles from './apiSettings.css';
import { getApiSettings, putApiKey, putApiZapierDisconnect } from '../../../../../../data/apiSettings/actions';
import { useSelector, useDispatch } from 'react-redux';
import Close from '../../../../../../assets/svg/close.svg';
import Shewron from '../../../../../../assets/svg/chevron.svg';
import ZapierIcon from '../../../../../../assets/img/zapier.png';
import Textarea from 'react-textarea-autosize';

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
const ApiSettings = ( { closeHandle } ) => {
    const dispatch = new useDispatch();
    const { profile, api, localization: { content: { custom_api, connected, need_custom, contact_us, service_support, disconnected, use_disposable_key } } } = useSelector( state => state );
    const [ name, setName ] = useState( '' );
    const [ apiConnect, setApiConnct ] = useState( false );
    const [ showZapier, setShowZapier ] = useState( false );
    const [ showCoop, setShowCoop ] = useState( false );
    const [ zapierKey, setZapierKey ] = useState( '' );
    const [ zapierConnect, setZapierConnect ] = useState( false );

    useEffect( () => {
        dispatch( getApiSettings() );
    }, [] );

    useEffect( () => {
        if ( profile?.api_settings ) {

            if ( profile?.api_settings?.coop ) {
                const { coop: { name, coop_connect } } = profile.api_settings;
                const responseName = name !== null ? name : '';
                setName( responseName );
                setApiConnct( coop_connect );
            }

            if ( profile?.api_settings?.zapier ) {
                const { zapier: { zapier_connect } } = profile.api_settings;
                setZapierConnect( zapier_connect );
            }
        }

        if ( api?.zapier ) {
            const { api_key } = api.zapier;
            setZapierKey( api_key );
        }

    }, [ api ] );


    const zapirClick = () => {
        setShowZapier( !showZapier );
    };

    const coopClick = () => {
        setShowCoop( !showCoop );
    };

    const zapierDisconnectClick = () => {
        if ( zapierConnect ) {
            dispatch( putApiZapierDisconnect() );
        }
    };

    const zapierConnectClick = () => {

        if ( !zapierKey ) {
            dispatch( putApiKey() );
        } else {
            window.open( 'https://zapier.com/developer/public-invite/168345/b7e4005eeeed48935ce51c1dc80d7f03/', '_blank' );
        }
    };

    return (
        <div className={ styles.overlay }>
            <div
                className={ styles.wrapper }>
                <Close onClick={ closeHandle }/>
                <h3>{ service_support }</h3>
                <div className={ styles.buttonPanel } onClick={ zapirClick }>
                    <h3>Zapier</h3>
                    <Shewron className={ showZapier ? styles.openPanel : styles.closePanel }/>
                </div>
                { showZapier &&
                <div className={ styles.customApiImageWrapper }>
                    <div className={ styles.imageWrapper }>
                        <img src={ ZapierIcon } rel={ 'zapier' } alt='Zapier icon'/>

                        { !zapierConnect && zapierKey && <div className={ styles.zapierKeyWrapper }>
                            <h4>{ use_disposable_key }</h4>
                            <Textarea
                                className={ styles.descriptionInput }
                                value={ zapierKey }
                                maxRows={ 3 }
                            />
                        </div> }

                        { !zapierConnect ?
                            <div className={ styles.connectButtonWrapper }>
                                <a onClick={ zapierConnectClick } className={ styles.disconnect }>
                                    Connect
                                </a>
                            </div> :

                            <div className={ styles.buttonWrapper }>
                                <div>
                                    <a onClick={ zapierDisconnectClick } className={ styles.disconnect }>
                                        Disconnect
                                    </a>
                                </div>
                                <div className={ styles.borderStyle }>
                                    <a href={ 'https://zapier.com/developer/public-invite/168345/b7e4005eeeed48935ce51c1dc80d7f03/' }>Edit</a>
                                </div>
                            </div> }
                    </div>

                </div> }
                <div className={ styles.buttonPanel } onClick={ coopClick }>
                    <h3>{ custom_api }</h3>
                    <Shewron className={ showCoop ? styles.openPanel : styles.closePanel }/>
                </div>
                { showCoop &&
                <div className={ styles.customApiWrapper }>

                    <h3>{ name } - <span
                        className={ apiConnect ? styles.connect : styles.disconnect }>{ apiConnect ? connected : disconnected }</span>
                    </h3>

                </div> }
                <h4>{ need_custom }
                    <a href={ 'https://millionmind.com/' } target={ '_blank' }>{ contact_us }</a>
                </h4>
            </div>

        </div>
    );
};


export default ApiSettings;